import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./auth/ProtectedRoute.js";
import { Contractors } from "./routes/Contractors.js";
import { ContractorDetail } from "./routes/ContractorDetail.js";
import { Customers } from "./routes/Customers.js";
import { FollowUps } from "./routes/FollowUps.js";
import { Placeholder } from "./routes/Placeholder.js";
import { RfqDetail } from "./routes/RfqDetail.js";
import { Shell } from "./routes/Shell.js";
import { SignIn } from "./routes/SignIn.js";
import { Team } from "./routes/Team.js";

/**
 * Operations Console routes. Everything except /sign-in is behind the staff
 * session. The nav targets are placeholders in O1 — the contractor
 * management screens land in O3, customers and insights after.
 */
export function App() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignIn />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Shell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/contractors" replace />} />
        <Route path="contractors" element={<Contractors />} />
        <Route path="contractors/:contractorId" element={<ContractorDetail />} />
        <Route path="customers" element={<Customers />} />
        <Route path="customers/:rfqId" element={<RfqDetail />} />
        <Route path="follow-ups" element={<FollowUps />} />
        {/* Admin-only in practice; the page itself checks, so a support
            staffer following a link gets an explanation, not a blank screen. */}
        <Route path="team" element={<Team />} />
        <Route
          path="insights"
          element={<Placeholder title="Insights" note="Usage analytics dashboards arrive once the event pipeline is wired." />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
